import React, { Component } from 'react';
import styled from 'styled-components';
import '../index.css';
import { ReactComponent as CheckIcon } from '../icons/hover_item_check.svg';

function MyVideo(props) {
  const isSelected = props.selectedVideoId === props.videoId; //this video selected?

  return (
    <div
      className="my-videos"
      style={{
        width: 589,
        height: 135,
        padding: 10,
        display: 'flex',
        flexDirection: 'row',
      }}
      onClick={props.handleCheckVideo}
    >
      {/* 썸네일 */}
      <div
        style={{
          width: 205.08,
          height: 119,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          backgroundColor: 'grey',
          position: 'relative',
          borderRadius: 5,
          border: '2px solid #CCCCCC',
        }}
      >
        <img
          width={205.08}
          src={props.img}
          alt="썸네일"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            backgroundColor: 'grey',
            borderRadius: 5,
          }}
        ></img>

        {/* hover 되었을 때 보이는 테두리 */}
        <div
          className="my-videos-buttons"
          style={{
            width: 205.08,
            height: 119,
            padding: 5,
            border: '5px #FFB600 solid',
            display: 'flex',
            flexDirection: 'row',
            position: 'absolute',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 5,
            left: -2,
            top: -2,
          }}
        >
          <CheckIcon />
        </div>

        {/* 선택하면 테두리 고정 */}
        {isSelected ? (
          <div
            style={{
              width: 205.08,
              height: 119,
              padding: 5,
              border: '5px #FFB600 solid',
              display: 'flex',
              flexDirection: 'row',
              position: 'absolute',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 5,
              left: -2,
              top: -2,
            }}
          >
            <CheckIcon />
          </div>
        ) : null}
      </div>

      <div
        style={{
          height: 119,
          display: 'flex',
          flexDirection: 'column',
          marginLeft: 10,
          justifyContent: 'space-between',
        }}
      >
        <p
          style={{
            fontSize: 25,
            fontWeight: 400,
            color: 'black',
            alignItems: 'start',
          }}
        >
          {props.title}
        </p>
        <p
          style={{
            fontSize: 22,
            fontWeight: 400,
            color: '#848484',
            alignItems: 'end',
          }}
        >
          {props.date}
        </p>
      </div>
    </div>
  );
}

export default MyVideo;
